module.exports = __webpack_public_path__ + "img/LATAM_ANIMAL_FATS.65980109.png";